import { z } from 'zod';
import { booleanQuery, dateSchema, idSchema, nonNegativeMoneySchema } from './common.schema.js';
/** A construction site ("budowa"). One physical building may host several. */
export const projectSchema = z.object({
    id: idSchema,
    code: z.string(),
    name: z.string(),
    isActive: z.boolean(),
    contractValue: nonNegativeMoneySchema.nullable(),
    managerIds: z.array(idSchema),
    /**
     * Archive (24.09.2026): a settled site moved out of every list and picker,
     * whole, and kept for the warranty years. Reversible from "Archiwum budów".
     */
    archivedAt: dateSchema.nullable(),
});
export const createProjectSchema = z.object({
    code: z
        .string()
        .min(2, 'Kod budowy musi mieć co najmniej 2 znaki')
        .max(32, 'Kod budowy jest za długi')
        .regex(/^[A-Z0-9/_-]+$/, 'Kod może zawierać tylko wielkie litery, cyfry i znaki / _ -'),
    name: z.string().min(2, 'Podaj nazwę budowy').max(120),
    contractValue: nonNegativeMoneySchema.nullish(),
    managerIds: z.array(idSchema).default([]),
});
export const updateProjectSchema = createProjectSchema
    .partial()
    .extend({ isActive: z.boolean().optional() });
export const projectListQuerySchema = z.object({
    includeInactive: booleanQuery(false),
    /**
     * The "Archiwum budów" view: *only* archived sites, instead of the live
     * list. Everywhere else archived sites are invisible by construction.
     */
    archived: booleanQuery(false),
});
//# sourceMappingURL=project.schema.js.map